import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, UserIcon } from 'lucide-react';
export function EmpathySection() {
  return <section id="empathy-section" className="py-3 md:py-6 bg-gradient-to-b from-[#FFFDFB] to-white" data-id="element-51">
      <div className="max-w-3xl mx-auto px-5" data-id="element-52">
        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-3xl font-bold text-stone-900 text-center mb-8 md:mb-10 tracking-[-0.02em] leading-relaxed" data-id="element-53">
          <UserIcon className="w-6 h-6 md:w-7 md:h-7 text-brand-500 inline-block mb-1 mr-1" data-id="element-54" />
          <br className="hidden" data-id="element-55" />
          O que o seu cliente pensa
          <br data-id="element-56" />
          <span className="text-brand-600" data-id="element-57">nos primeiros 3 segundos</span>
          <br data-id="element-58" />e nunca vai te dizer
        </motion.h2>

        {/* Two-column comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-59">
          {/* Without method */}
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-stone-50 rounded-2xl overflow-hidden border border-stone-200" data-id="element-60">
            <div className="relative" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/qFeiN1gnTMrAQYSyjox3YX/semboutique.jpg" alt="Produto sem apresentação boutique" className="w-full h-56 md:h-64 object-cover" data-id="element-62" />
              <div className="absolute top-3 left-3" data-id="element-63">
                <span className="bg-stone-700 text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full shadow-md uppercase tracking-wide" data-id="element-64">
                  Sem método
                </span>
              </div>
            </div>
            <div className="p-3 md:p-4" data-id="element-65">
              <div className="flex items-start gap-2" data-id="element-66">
                <AlertTriangle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-67" />
                <p className="text-sm md:text-[15px] text-stone-500 leading-relaxed italic" data-id="element-68">
                  "Parece caseiro, sem qualidade. Não quero essa imagem no meu
                  casamento, não vou nem pedir o orçamento"
                </p>
              </div>
            </div>
          </motion.div>

          {/* With method */}
          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-brand-50/40 rounded-2xl overflow-hidden border-2 border-brand-200" data-id="element-69">
            <div className="relative" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/7TALHpXHu8W7NjYVoPqo57/WhatsApp_Image_2026-03-18_at_23.27.58.jpg" alt="Produto com apresentação boutique" className="w-full h-56 md:h-64 object-cover" data-id="element-71" />
              <div className="absolute top-3 left-3" data-id="element-72">
                <span className="bg-brand-500 text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full shadow-md uppercase tracking-wide" data-id="element-73">
                  Com método
                </span>
              </div>
            </div>
            <div className="p-3 md:p-4" data-id="element-74">
              <p className="text-sm md:text-[15px] text-brand-800 leading-relaxed italic font-medium" data-id="element-75">
                "Que capricho, essa apresentação me surpreendeu. Isso parece
                muito profissional, já quero um orçamento"
              </p>
            </div>
          </motion.div>
        </div>

        {/* Closing line */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="text-base md:text-lg text-stone-700 text-center mt-8 leading-relaxed font-medium tracking-[-0.01em]" data-id="element-76">
          Esse julgamento acontece em 3 segundos.{' '}
          <span className="text-brand-600 font-bold" data-id="element-77">
            O Efeito Boutique™ ensina a controlar o que acontece nesses 3
            segundos.
          </span>
        </motion.p>
      </div>
    </section>;
}